import React from 'react';
import {
  Brain, Target, Handshake, ScrollText, Globe, Microscope,
} from 'lucide-react';

const credentials = [
  {
    icon: ScrollText,
    title: 'Testépítés – Fitnesz Sportedző',
    detail: 'Államilag elismert szakképesítés, vizsgaközpont: Testnevelési Egyetem',
  },
  {
    icon: Globe,
    title: 'Europass Certificate Supplement',
    detail: 'Nemzetközileg elismert, hivatalos európai minősítés',
  },
  {
    icon: Microscope,
    title: 'Tudományosan megalapozott módszerek',
    detail: 'Ami bizonyítottan működik, nem divatos trendek',
  },
];

const coreValues = [
  {
    icon: Brain,
    title: 'Tudományos alapok',
    description:
      'Az edzéstervedet és az étrendedet a sporttudomány jelenlegi állására építem, nem divatdiétákra és mítoszokra.',
  },
  {
    icon: Target,
    title: '100% személyre szabottság',
    description:
      'Nincsenek másolható sablonok. Olyan programot kapsz, ami a testedhez, az időbeosztásodhoz és a céljaidhoz illeszkedik.',
  },
  {
    icon: Handshake,
    title: 'Folyamatos támogatás',
    description:
      'Nem engedem el a kezed. A heti visszajelzések és a rendszeres kapcsolattartás segítenek, hogy ne tévedj el az úton.',
  },
];

const CredentialsValuesSection = () => {
  return (
    <section id="credentials" data-testid="credentials-values-section" className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Credentials */}
        <div className="mb-20" data-testid="about-credentials">
          <div className="text-center mb-10">
            <div className="inline-block mb-3 px-4 py-2 bg-gray-900 rounded-full">
              <span className="text-yellow-400 font-semibold text-sm tracking-wider">KÉPESÍTÉSEK & ELISMERÉSEK</span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Hivatalos szakmai háttér
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {credentials.map((cred, index) => {
              const Icon = cred.icon;
              return (
                <div
                  key={index}
                  data-testid={`credential-card-${index}`}
                  className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-gray-800 hover:border-yellow-600/40"
                >
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-yellow-600/20 border border-yellow-600/30 rounded-lg mb-5">
                    <Icon className="text-yellow-400" size={28} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold mb-3 leading-tight break-words" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {cred.title}
                  </h3>
                  <p className="text-sm text-gray-300 leading-relaxed break-words">
                    {cred.detail}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Core Values */}
        <div data-testid="about-values">
          <div className="text-center mb-10">
            <div className="inline-block mb-3 px-4 py-2 bg-yellow-100 rounded-full">
              <span className="text-yellow-700 font-semibold text-sm tracking-wider">ALAPÉRTÉKEK</span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-bold text-gray-900"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Amire a közös munka épül
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {coreValues.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  data-testid={`core-value-${index}`}
                  className="bg-white border-2 border-gray-100 rounded-xl p-8 hover:border-yellow-600 hover:shadow-xl transition-all duration-300 group"
                >
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-yellow-100 rounded-lg mb-5 group-hover:bg-yellow-600 transition-colors duration-300">
                    <Icon className="text-yellow-600 group-hover:text-white transition-colors duration-300" size={28} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 break-words" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed break-words">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredentialsValuesSection;
